module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(!_vm.userXPIsWeb && (_vm.userXPIsAll || _vm.userXPIsMobile)) ? _c('div', {
    staticClass: "mv3"
  }, [_c('ak-alert', {
    staticClass: "font-size-responsive inter br-pill",
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n      Looking to add an item to your account? Download our mobile app on iOS or Android! Please "), _c('a', {
    attrs: {
      "href": "`/contact`"
    }
  }, [_vm._v("\n      contact support")]), _vm._v(" if you have any\n      questions.\n      "), _c('div', {
    staticClass: "flex-apps"
  }, [_c('a', {
    staticClass: "flex btn-ios btn-container",
    attrs: {
      "href": "https://akko.app/home"
    }
  }, [_c('img', {
    staticClass: "btn",
    attrs: {
      "alt": "Download on the iOS App Store",
      "src": require("../../static/download-app/download-on-the-app-store-logo.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "flex btn-container android",
    attrs: {
      "href": "https://akko.app/home"
    }
  }, [_c('img', {
    staticClass: "btn",
    attrs: {
      "alt": "Download on the Google PlayStore",
      "src": require("../../static/download-app/download-on-google-store.png")
    }
  })])])])], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row-l flex-column mt1"
  }, [_c('div', {
    staticClass: "mv3-l w-100-ns"
  }, [_c('ak-search', {
    model: {
      value: (_vm.searchParam),
      callback: function($$v) {
        _vm.searchParam = $$v
      },
      expression: "searchParam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mv3-l mt2 w-100-ns"
  }, [(!_vm.userXPIsMobile && (_vm.userXPIsWeb || _vm.userXPIsAll)) ? _c('ak-button', {
    staticClass: "mw5-l fr",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDevice.apply(null, arguments)
      }
    }
  }, [_vm._v("Add New Item\n        ")]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please contact\n        our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.$store.state.messages.length) ? _c('div', {
    staticClass: "mv4"
  }, _vm._l((this.$store.state.messages), function(message, index) {
    return _c('ak-alert', {
      key: index,
      attrs: {
        "color": message.color,
        "deleteable": message.deleteable
      },
      on: {
        "close": function($event) {
          return _vm.clearMessage(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(message.text))])])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.devices.length > 0 && _vm.userHasAccess) ? _c('div', {
    staticClass: "flex flex-wrap content justify-start"
  }, _vm._l((this.devices), function(device, index) {
    return _c('div', {
      key: index,
      staticClass: "card-width pa3 bg-white account-card mb4-l mb4-m pointer mr3"
    }, [_c('router-link', {
      staticClass: "no-underline black",
      attrs: {
        "to": ("/devices/" + (device.id))
      }
    }, [_c('ak-device-tile', {
      attrs: {
        "id": device.id,
        "brand": device.brand,
        "model": device.model,
        "nickname": device.nickname ? device.nickname : ("Item " + (index+1)),
        "serial": device.serial_number,
        "type": device.type
      }
    })], 1)], 1)
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height flex items-center justify-between"
  }, [_c('span', {
    staticClass: "f2-l f3 lh-copy mt4-l mt2 b"
  }, [_vm._v("Your Items")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72613615","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DevicesPage.vue
// module id = 1353
// module chunks = 0